<template>
    <div class="controlManage">
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        name: 'controlManage'
    }
</script>
<style scrop>
    .controlManage {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        display: flex;
    }
</style>